import React from "react";
import NavBar from "./components/NavBar";

const HeaderContainer = (props) => {
    return <NavBar checkDrawerOpen={props.checkDrawerOpen}/>
}

export default HeaderContainer;